import {
  OptSideLayoutPortalContainer,
  OptSideLayoutPortalContent,
} from "@optsol/react";
import { Route, Switch } from "react-router-dom";
import { Rotas } from ".";
import { ImportarPassageiros } from "../paginas/importar-passageiros";
import { ViewImportarPassageirosEvento } from "../paginas/importar-passageiros-evento";


export const ImportacaoRoutes = () => {
  return (
    <OptSideLayoutPortalContainer>
      <OptSideLayoutPortalContent>
        <Switch>
          <Route exact path={Rotas.Importacao.Importar}>
            <ImportarPassageiros />
          </Route>
          <Route exact path={Rotas.ImportacaoPassageirosEvento.Importar}>
            <ViewImportarPassageirosEvento />
          </Route>
        </Switch>
      </OptSideLayoutPortalContent>
    </OptSideLayoutPortalContainer>
  );
};
